import React from "react";
import { ReactComponent as Twitter } from "../../assets/icons/twitter.svg";
import { ReactComponent as Discord } from "../../assets/icons/discord.svg";
import { ReactComponent as Medium } from "../../assets/icons/medium.svg";
import { ReactComponent as Telegram } from "../../assets/icons/telegram.svg";

const IconTypes: {
  [key: string]: React.FC<React.SVGProps<SVGSVGElement>>;
} = {
  twitter: Twitter,
  discord: Discord,
  medium: Medium,
  telegram: Telegram,
};

type IconProps = {
  name: string;
} & React.SVGAttributes<SVGElement>;

const Icon: React.FC<IconProps> = (props) => {
  const IconComponent = IconTypes[props.name];
  return <IconComponent {...props} />;
};

export default Icon;
